import intlTelInput from 'intl-tel-input';
import VMasker from 'vanilla-masker';
import '../../styles/elementor-setpar.scss';

import _ from 'lodash';

const ELEMENT_ID = 'form-field-customphone';
const DEFAULT_COUNTRY = 'br';

class InternationPhoneInput {
  render() {
    if (
      window.intlTelInputGlobals &&
      Object.values(window.intlTelInputGlobals.instances).length > 0
    ) {
      Object.values(window.intlTelInputGlobals.instances).map(instance =>
        instance.destroy()
      );
    }

    var phoneInputField = document.querySelector(`#${ELEMENT_ID}`);
    if (!phoneInputField) return;

    var onlyCountries = window.options?.countries || [];
    var preferredCountries = [DEFAULT_COUNTRY];
    var currentCountry = window.options?.current_country;
    if (currentCountry && currentCountry != DEFAULT_COUNTRY) {
      onlyCountries.push(currentCountry);
      preferredCountries.unshift(currentCountry);
    }

    const options = {
      preferredCountries,
      onlyCountries: onlyCountries.sort(),
      utilsScript:
        'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js',
    };

    var intlPhoneInput = intlTelInput(phoneInputField, options);

    var ddiInput = document.getElementById('form-field-ddi');
    var phoneInput = document.getElementById('form-field-phone');
    var dddInput = document.getElementById('form-field-ddd');

    var BRAZIL_DDI = '55';
    var max = 14;
    var masks = ['(99) 9999-9999', '(99) 99999-9999'];

    function inputAndCountryHandler() {
      var target = phoneInputField;
      var value = target.value.replace(/\D/g, '');

      var ddi = intlPhoneInput.getSelectedCountryData().dialCode;
      var phoneNumber = intlPhoneInput.getNumber();
      var digits = phoneNumber.replace(/\D/g, '');
      var phoneWithoutDDI = digits.replace(ddi, '');

      ddiInput.value = ddi;

      if (ddi === BRAZIL_DDI) {
        var mask = target.value.length > max ? 1 : 0;
        var maskOnlyDigits = masks[mask].replace(/\D/g, '');
        var ddd = phoneWithoutDDI.slice(0, 2);

        phoneWithoutDDI = phoneWithoutDDI.slice(0, maskOnlyDigits.length);

        target.value = VMasker.toPattern(value, masks[mask]);
        VMasker(target).maskPattern(masks[mask]);

        phoneInput.value = phoneWithoutDDI.slice(2, phoneWithoutDDI.length);
        dddInput.value = ddd;
        return;
      }

      VMasker(target).unMask();
      phoneInput.value = phoneWithoutDDI;
      target.value = value;
      dddInput.value = '';
    }

    phoneInputField.addEventListener('countrychange', inputAndCountryHandler);
    phoneInputField.addEventListener('input', inputAndCountryHandler);
  }

  constructor() {
    const processChange = _.debounce(() => this.render(), 500);

    let observer = new MutationObserver(() => {
      if (document.getElementById(ELEMENT_ID)) {
        return processChange();
      }
      return '';
    });
    observer.observe(document.body, { childList: true });
  }
}

export default InternationPhoneInput;
